interface NavItem {
  icon: string;
  label: string;
  href: string;
  active: boolean;
  badge?: number;
}

interface FieldBottomNavProps {
  items: NavItem[];
  onNavigate: (href: string) => void;
}

export default function FieldBottomNav({ items, onNavigate }: FieldBottomNavProps) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#E8EAED] z-50" style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}>
      <div className="flex items-center justify-around h-14 max-w-lg mx-auto">
        {items.map((item) => (
          <button
            key={item.href}
            onClick={() => onNavigate(item.href)}
            className={`flex flex-col items-center justify-center gap-0.5 w-full h-full transition-colors relative ${
              item.active ? "text-[#1B6E4F]" : "text-[#3F4A52]/60"
            }`}
          >
            <div className="relative w-6 h-6 flex items-center justify-center">
              <i className={`${item.icon} text-xl`} />
              {item.badge !== undefined && item.badge > 0 && (
                <span className="absolute -top-1 -right-2 min-w-[16px] h-4 rounded-full bg-[#D32F2F] text-white text-[10px] font-bold flex items-center justify-center px-1">
                  {item.badge > 99 ? "99+" : item.badge}
                </span>
              )}
            </div>
            <span className="text-[10px] font-medium leading-none whitespace-nowrap">{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}